import { FunctionComponent } from 'react'
import { Icon } from 'utils'

interface AddMoreInterface {
  handleClick: () => void
}

const AddMore: FunctionComponent<AddMoreInterface> = ({ handleClick }) => {
  return (
    <button
      type="button"
      className="btn-tertiary btn-mobile "
      onClick={handleClick}
    >
      <span className="btn-tertiary">
        <Icon
          role="presentation"
          id="#circle-cross-outline"
          width="22"
          height="22"
          fill="#006ba6"
        />
      </span>{' '}
      Add more
    </button>
  )
}

export default AddMore
